import { motion } from "framer-motion";
import { ArrowDown, ArrowUpRight } from "lucide-react";

const ease = [0.22, 1, 0.36, 1];

export const Hero = () => (
  <section
    id="top"
    data-testid="hero-section"
    className="relative flex min-h-screen items-center overflow-hidden bg-black"
  >
    <div className="relative mx-auto w-full max-w-7xl px-6 pb-24 pt-32">
      <motion.p
        initial={{ opacity: 0, y: 24 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.7, delay: 0.15, ease }}
        className="font-mono text-xs uppercase tracking-[0.35em] text-zinc-400"
      >
        Desires After Hours · Private Networking
      </motion.p>

      <motion.h1
        initial={{ opacity: 0, y: 32 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8, delay: 0.3, ease }}
        data-testid="hero-heading"
        className="mt-6 max-w-5xl font-display text-4xl font-extrabold uppercase leading-[0.95] tracking-tight sm:text-6xl lg:text-7xl"
      >
        The one-stop shop for all of your desires.
      </motion.h1>

      <motion.p
        initial={{ opacity: 0, y: 24 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.7, delay: 0.45, ease }}
        className="mt-8 max-w-xl text-sm leading-relaxed text-zinc-400 sm:text-base"
      >
        Networking events, private meets, curated chats and more — one discreet
        company for the connections that move your world.
      </motion.p>

      <motion.div
        initial={{ opacity: 0, y: 24 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.7, delay: 0.6, ease }}
        className="mt-12 flex flex-wrap items-center gap-4"
      >
        <a
          href="#services"
          data-testid="hero-explore-button"
          className="inline-flex items-center gap-2 rounded-full bg-white px-7 py-3 text-xs font-semibold uppercase tracking-[0.15em] text-black transition-[background-color,transform] duration-300 hover:-translate-y-0.5 hover:bg-zinc-300"
        >
          Explore Services <ArrowDown className="h-4 w-4" />
        </a>
        <a
          href="#contact"
          data-testid="hero-contact-button"
          className="inline-flex items-center gap-2 rounded-full border border-white/20 px-7 py-3 text-xs font-semibold uppercase tracking-[0.15em] text-white transition-[border-color,background-color,transform] duration-300 hover:-translate-y-0.5 hover:border-white/40 hover:bg-white/5"
        >
          Contact Desires After Hours <ArrowUpRight className="h-4 w-4" />
        </a>
      </motion.div>
    </div>
  </section>
);
